import { Card, CardContent } from "@/components/ui/card";
import { Gauge } from "lucide-react";

const gradeColors = {
  A: { bg: "bg-emerald-500", ring: "ring-emerald-200", text: "text-emerald-600" },
  B: { bg: "bg-sky-500", ring: "ring-sky-200", text: "text-sky-600" },
  C: { bg: "bg-amber-500", ring: "ring-amber-200", text: "text-amber-600" },
  D: { bg: "bg-orange-500", ring: "ring-orange-200", text: "text-orange-600" },
  F: { bg: "bg-red-500", ring: "ring-red-200", text: "text-red-600" },
};

export default function EngineRating({ rating }) {
  if (!rating) return null;
  const colors = gradeColors[rating.grade] || gradeColors.C;
  const pct = rating.overall_rating;
  const circumference = 2 * Math.PI * 54;
  const offset = circumference - (pct / 100) * circumference;

  return (
    <Card className="border border-slate-200 shadow-none rounded-sm overflow-hidden" data-testid="engine-rating-card">
      <div className="border-b border-slate-200 p-4 bg-slate-50/50 flex items-center gap-2">
        <Gauge size={18} className="text-slate-500" />
        <span className="text-sm font-bold uppercase tracking-wider text-slate-600">Engine Health Rating</span>
      </div>
      <CardContent className="p-5 flex flex-col items-center">
        {/* Circular gauge */}
        <div className="relative w-36 h-36 mb-4">
          <svg className="w-full h-full -rotate-90" viewBox="0 0 120 120">
            <circle cx="60" cy="60" r="54" fill="none" stroke="#E2E8F0" strokeWidth="8" />
            <circle
              cx="60" cy="60" r="54" fill="none"
              className={colors.bg.replace('bg-', 'stroke-')}
              strokeWidth="8"
              strokeLinecap="round"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              style={{ transition: "stroke-dashoffset 1s ease-in-out" }}
            />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className={`text-4xl font-bold font-['Barlow'] ${colors.text}`}>{pct}</span>
            <span className="text-sm uppercase tracking-widest text-slate-500 font-bold">/ 100</span>
          </div>
        </div>

        <div className={`text-xl font-bold uppercase tracking-wider font-['Barlow'] ${colors.text}`} data-testid="engine-grade">
          Grade {rating.grade} - {rating.label}
        </div>

        {/* Factors */}
        <div className="w-full mt-5 space-y-3">
          {rating.factors?.map((f, i) => (
            <div key={i} className="flex items-center justify-between text-sm">
              <span className="text-slate-600 font-medium">{f.name}</span>
              <div className="flex items-center gap-2">
                <div className="w-24 h-2 bg-slate-100 rounded-full overflow-hidden">
                  <div
                    className={`h-full rounded-full ${f.status === 'good' ? 'bg-emerald-500' : f.status === 'warning' ? 'bg-amber-500' : 'bg-sky-500'}`}
                    style={{ width: `${(f.score / f.max) * 100}%` }}
                  />
                </div>
                <span className="font-mono text-slate-700 font-medium w-10 text-right">{f.score}/{f.max}</span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
